import React, { useState, useRef } from 'react'
import { ExcelRenderer } from 'react-excel-renderer'

import { Button, Modal, notification, Row, Space, Upload, Table } from 'antd'

import { ImportOutlined, LinkOutlined, CloudUploadOutlined } from '@ant-design/icons'

//apis
import { importProduct } from 'apis/product'

export default function ImportProducts({ reload }) {
  const typingTimeoutRef = useRef()

  const [columns, setColumns] = useState([])
  const [dataView, setDataView] = useState([])

  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)

  const [valueFileImport, setValueFileImport] = useState(null)
  const [loading, setLoading] = useState(false)

  const _importFile = async () => {
    try {
      if (!valueFileImport) {
        notification.warning({ message: 'Vui lòng nhập file import' })
        return
      }
      setLoading(true)
      const formData = new FormData()
      formData.append('file', valueFileImport)
      const res = await importProduct(formData)
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          setValueFileImport(null)
          toggle()
          notification.success({ message: 'Import món thành công!' })
          reload()
        } else notification.error({ message: res.data.message || 'Import món thất bại!' })
      } else notification.error({ message: res.data.message || 'Import món thất bại!' })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  return (
    <>
      <Button
        onClick={toggle}
        style={{ minWidth: 130 }}
        type="primary"
        size="large"
        icon={<ImportOutlined />}
      >
        Import món ăn
      </Button>

      <Modal
        width="90%"
        style={{ top: 20 }}
        footer={
          <Row justify="end">
            <Space>
              <Button type="primary" danger onClick={toggle}>
                Đóng
              </Button>
              <Button
                loading={loading}
                onClick={_importFile}
                type="primary"
                disabled={!valueFileImport ? true : false}
              >
                Import
              </Button>
            </Space>
          </Row>
        }
        visible={visible}
        onCancel={toggle}
        title={
          <a
            href="https://admin-order.s3.ap-northeast-1.wasabisys.com/2022/01/10/e2073616-c709-4e53-8434-2d285f39dff6/ImportProductTemplated.xlsx"
            target="_blank"
          >
            <Button icon={<LinkOutlined />} type="link">
              Download Template
            </Button>
          </a>
        }
      >
        <Upload
          fileList={valueFileImport ? [valueFileImport] : []}
          maxCount={1}
          onChange={(info) => {
            if (info.file.status !== 'done') info.file.status = 'done'
            setValueFileImport(info.file.originFileObj)

            if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current)
            typingTimeoutRef.current = setTimeout(() => {
              if (info.file.originFileObj) {
                ExcelRenderer(info.file.originFileObj, (err, resp) => {
                  if (err) console.log(err)
                  else {
                    if (resp.rows[0]) {
                      const columns = resp.rows[0].map((item) => {
                        return { title: item, dataIndex: item }
                      })
                      setColumns([...columns])
                    }

                    let result = []
                    for (let i = 1; i < resp.rows.length; ++i) {
                      if (resp.rows[i].length) {
                        let obj = {}
                        for (let j = 0; j < resp.rows[0].length; ++j)
                          if (resp.rows[0][j]) obj[resp.rows[0][j]] = resp.rows[i][j] || ''

                        result.push(obj)
                      }
                    }
                    setDataView([...result])
                  }
                })
              } else {
                setColumns([])
                setDataView([])
              }
            }, 400)
          }}
        >
          <Button>Chọn file excel</Button>
        </Upload>
        <Row style={{ marginTop: 15 }} justify="end">
          <Table
            sticky
            scroll={{ x: 'max-content', y: '50vh' }}
            size="small"
            style={{ width: '100%', display: !valueFileImport && 'none' }}
            dataSource={dataView}
            columns={columns.map((column) => {
              return { ...column, width: column.title.length * 20 }
            })}
            pagination={false}
          />
        </Row>
      </Modal>
    </>
  )
}
